<app-applicant-funnel-message-dialog
    [subject]="applicantJobFunnelMessageTemplate?.subject"
    [openDialog]="isChangeFunnelStageModalOpen"
    (confirmChangeFunnelStage)="onConfirmChangeFunnelStage()"
    (closeChangeFunnelStage)="onCloseChangeFunnelStage()"
>
</app-applicant-funnel-message-dialog>

<div class="page-container">
    <app-header title="applicant-tracker.applicants.title" [menuService]="recruitingModuleMenuService">
        <div class="buttons">
            <ui-button [url]="'/recruiting/bulk-applicant-message'" type="ghost">{{
                'applicant-tracker.email-applicants' | translate
            }}</ui-button>
            <ui-button [routerLink]="['/', 'recruiting', 'applicants', 'create']" type="primary">
                <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                {{ 'applicant-tracker.create-applicant' | translate }}
            </ui-button>
        </div>
    </app-header>

    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table
            [table]="table"
            (dropdownSelectionChanged)="onChangeFunnelStage($event)"
            (allFiltersCleared)="onAllFiltersCleared()"
            (filterChanged)="onFilterChange($event)"
            (searchQueryChanged)="onSearchQueryChange($event)"
            [searchPlaceholder]="searchPlaceHolder"
            [searchWidth]="searchWidth"
            [isResponsive]="true"
            [showOffset]="true"
            [noPadding]="true"
            [embedded]="true"
        >
            <div class="buttons">
                <ui-button type="outline" [matMenu]="exportMenu">
                    {{ 'applicant-tracker.export' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
                </ui-button>
                <mat-menu #exportMenu="matMenu">
                    <button mat-menu-item (click)="onExport('csv')">
                        {{ 'applicant-tracker.export-as-csv' | translate }}
                    </button>
                    <button mat-menu-item (click)="onExport('xlsx')">
                        {{ 'applicant-tracker.export-as-xlsx' | translate }}
                    </button>
                </mat-menu>
            </div>
            <div class="empty">
                <img style="max-width: 30%" src="/assets/illustrations/magnifying-glass.png" />
                <h2 class="ui centered header">{{ 'applicant-tracker.no-applicants' | translate }}</h2>
            </div>
        </app-table>
    </ui-card>
</div>
